import React, { Component } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

import AttachFile from '@mui/icons-material/AttachFile';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
	borderWidth: 1,
	borderStyle: "solid",
	fontSize: "1.6rem",
	width: theme.spacing(5.25),
	height: theme.spacing(5.25),
}));

const AttachIcon = styled(AttachFile)(({ theme }) => ({
	color: theme.palette.action.active,
}));

const CountSpan = styled('span')(({ theme }) => ({
	marginLeft: theme.spacing(1.5),
	color: theme.palette.text.primary,
	fontSize: "1.2em"
}));

class UploadButton extends Component {
	render() {
		let {selectFileHandler, count} = this.props;
		let inputId = (Math.random() * 1e+18).toString(36).slice(0, 8);
		
		return (
			<div>
				<input 
					hidden
					id={inputId}
					accept="image/*"
					type="file"
					multiple
					aria-hidden="true"
					onChange={selectFileHandler}
				/>
				<StyledIconButton
					aria-label="attach images"
					ga-on="click"
					ga-event-category="WebApp"
					ga-event-action="Button Pressed"
					ga-event-label="Attachments"
					component="span" 
					color="primary"
					onClick={() => document.getElementById(inputId).click()}
				>
					<AttachIcon />
				</StyledIconButton>
				<CountSpan>{count}</CountSpan>
			</div>
		);
	}
}

UploadButton.propTypes = {
	selectFileHandler: PropTypes.func.isRequired,
	count: PropTypes.number
};

export default UploadButton;